export default __webpack_public_path__ + "static/media/droits_delegues.d2f4b036.svg";